export const API_URL = 'https://industrypqf.com/api/api';
//export const API_URL = 'https://industrypqf-staging.azurewebsites.net/api/api';
//export const API_URL = 'http://localhost:5001/api';
export const API_AUTHORIZATION_URL = `${API_URL}/Token`;
